import { schema } from 'normalizr'

// Schemas
import { userSongSchema } from 'modules/usersongs/models'
import { licenseTypeList } from 'normalize'

// Types
import type { PaymentState } from 'types'

export type LicenseRevenue = {
  id: number
  share_percentage: number
  category: number
  royalty_percentage: number
  tracklib_percentage: number
  ordering: number
  sample_type: number
}

export type LicenseType = {
  id: number
  revenue_set: Array<number>
  name: string
  description: string
  description_short: string
  ordering: number
  max_seconds: number
  license_version: number
}

export type LicenseVersion = {
  id: number
  version: number
  sample_types: Array<number>
}

export type LicenseVersionWithLicenseTypes = Omit<LicenseVersion, 'sample_types'> & {
  sample_types: Array<LicenseType>
}

export type SampleLicenseOrder = {
  id: number
  currency: string
  payment_url: string
  state: PaymentState
  total_amount: number
  user_song_sample: number
  user_song: number
  user: number
  vat_rate: number
  vat_amount: number
}

export const licenseVersionSchema = new schema.Entity('licenseVersions', {
  sample_types: licenseTypeList,
})

export const licenseVersionListSchema = [licenseVersionSchema]

export const sampleLicenseOrderSchema = new schema.Entity('sampleLicenseOrders', {
  user_song: userSongSchema,
})

export const sampleLicenseOrderListSchema = [sampleLicenseOrderSchema]
